import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { UserTracker } from './UserTracker';
import { UserTrackerContext } from './UserTrackerContext';
import { MatomoTracker } from './MatomoTracker';
import { FullStoryTracker } from './FullStoryTracker';
import { ConsoleTracker } from './ConsoleTracker';
export function RegisterUser({ children, user, enableTracking, fullstoryOrgId, matomoSiteId }) {
    const validInstance = enableTracking;
    const Context = UserTrackerContext;
    const memoizedValue = useMemo(() => {
        if (!validInstance) {
            return null;
        }
        const tracker = new UserTracker([
            new MatomoTracker(matomoSiteId),
            new FullStoryTracker(fullstoryOrgId),
            new ConsoleTracker(),
        ]);
        if (user) {
            tracker.identify(user);
        }
        return tracker;
    }, []);
    if (validInstance) {
        return (_jsx(Context.Provider, { value: memoizedValue, children: children }));
    }
    return (_jsxs(_Fragment, { children: [' ', children, ' '] }));
}
